import { LeadsWorkspace } from "@/pages/sales/crm/page";

export default function AdminLeadsPage() {
  return <LeadsWorkspace mode="admin" />;
}
